import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * V2 LiveNowCards — Phase 1 stub (scraping required).
 *
 * Black OS version shows scrollable avatar cards of creators currently live.
 * NoiRock Generic Phase 1 has no live signal — render a neutral placeholder
 * card. Will be replaced when `pages.manager.live` scraping infra exists.
 */
const LiveNowCardsStub = () => {
  const { t } = useTranslation();
  return (
    <div className="rounded-2xl bg-card border border-border p-5">
      <div className="flex items-center justify-between mb-3">
        <div className="font-heading font-semibold text-foreground text-sm">
          {t('adminV2.modules.liveNow.title', 'Currently live')}
        </div>
        <span className="text-[10px] uppercase tracking-widest text-muted-foreground/60 font-data bg-muted px-2 py-1 rounded">
          Phase 2
        </span>
      </div>
      <p className="text-xs text-muted-foreground">
        {t(
          'adminV2.modules.liveNow.stubMessage',
          'Real-time live monitoring requires scraping. Enable the feature once the pipeline is wired.'
        )}
      </p>
    </div>
  );
};

export default LiveNowCardsStub;
